import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { api, currentYM } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { PageLoader } from "@/components/PageLoader";
import { ArrowLeft } from "lucide-react";
import { PerformanceView } from "@/components/PerformanceView";

export default function EmployeePerformance() {
  const nav = useNavigate();
  const [period, setPeriod] = useState(currentYM());
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [animatedScore, setAnimatedScore] = useState(0);

  useEffect(() => {
    let cancel = false;
    setLoading(true);
    api.get("/performance/me", { params: { period } })
      .then((r) => { if (!cancel) setData(r.data); })
      .finally(() => { if (!cancel) setLoading(false); });
    return () => { cancel = true; };
  }, [period]);

  useEffect(() => {
    if (!data) return;
    const target = data.score.value;
    let cur = 0;
    const step = target / 30;
    const iv = setInterval(() => {
      cur += step;
      if (cur >= target) { cur = target; clearInterval(iv); }
      setAnimatedScore(cur);
    }, 30);
    return () => clearInterval(iv);
  }, [data]);

  if (loading && !data) return <PageLoader label="Menghitung performa..." />;
  if (!data) return null;

  return (
    <div className="px-4 py-6 pb-24 max-w-md mx-auto" data-testid="employee-performance">
      <div className="flex items-center gap-2 mb-4">
        <Button variant="ghost" size="icon" onClick={() => nav(-1)} className="h-8 w-8" data-testid="btn-back">
          <ArrowLeft className="w-4 h-4" />
        </Button>
        <div className="flex-1">
          <p className="overline">Performa</p>
          <h1 className="font-display text-xl font-bold tracking-tight">{data.user_name}</h1>
        </div>
        <Input type="month" value={period} onChange={(e) => setPeriod(e.target.value)} className="w-32 text-xs" data-testid="perf-period" />
      </div>

      <PerformanceView data={data} animatedScore={animatedScore} />
    </div>
  );
}
